import styled from 'styled-components';
import colors from '../../styles/colors';

export const ErrorMessage = styled.p`
  position: relative;  
  display: flex;
  font-size: 18px;
  color: ${colors.functional.errorRed};
  margin-right: auto;
`;

export const TooltipContainer = styled.div` 
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 10px 12px;
  >span{
    margin:0;
    margin-left: auto;
  }
  .tippy-1{
    z-index: 1;
  }
`;
